import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import ITRReportPageUI from './ITRReportPageUI.js'

class ITRReportPageSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            profitAndLossList: [],
            balanceSheetList: [],
            chargeValueCalculation: null,
            editable: false,
        }
    }

    render() {
        return (
            <ITRReportPageUI
                context={this.props.context}
                account={this.state.account}
                profitAndLossList={this.state.profitAndLossList}
                balanceSheetList={this.state.balanceSheetList}
                chargeValueCalculation={this.state.chargeValueCalculation}
                toggleEditable={() => { this.setState({ editable: !this.state.editable }) }}
                editable={this.state.editable}
                onRefreshClick={this.onRefreshClick}
            />
        )
    }

    componentDidMount() {
        let context = this.props.context
        this.getAccounts(context)
        this.getITRReport(context)
    }

    getITRReport(context) {
        let cacheManager = new CacheManager({
            resource: `/api/su/accounts/${this.props.match.params.accountId}/itr`,
            cacheKey: CacheKeys.ITRReport(this.props.match.params.accountId),
            callback: this.getITRReportCallback,
            ttlInSecs: 600
        })
        cacheManager.getObject2(context)
    }

    getITRReportCallback = (response) => {
        this.setState({
            profitAndLossList: response.profitAndLossList,
            balanceSheetList: response.balanceSheetList,
            chargeValueCalculation: response.chargeValueCalculation
        })
    }

    getAccounts(context) {
        let cacheManager = new CacheManager({
            resource: `/api/su/accounts/${this.props.match.params.accountId}`,
            cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
            callback: this.getAccountsCallback,
            ttlInSecs: 600
        })
        cacheManager.getObject2(context)
    }

    getAccountsCallback = (response) => {
        this.setState({ account: response.account })
    }

    onRefreshClick = () => {
        let context = this.props.context
        CacheManager.removeObject(CacheKeys.ITRReport(this.props.match.params.accountId))
        this.setState({ itrReport: null, profitAndLossList: null, chargeValueCalculation: null },
            this.getITRReport(this.props.context),
        )
    }
}

export default withRouter(ITRReportPageSF)
